import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  signedDate: null,
};

export const signedDateSlice = createSlice({
  name: "signedDate",
  initialState,
  reducers: {
    setSignedDate: (state, action) => {
      state.signedDate = action.payload;
    },
  },
});

export const { setSignedDate } = signedDateSlice.actions;

export default signedDateSlice.reducer;
